/**
 * Peak-hold sampler: keeps the peak of levels polled on an interval, because
 * a single instantaneous sample at the chunk boundary would mistake a natural
 * pause in the conversation for silence.
 */
export class AudioLevelMonitor {
  private timer: number | null = null;
  private peak = 0;

  constructor(
    private readonly getLevel: () => number,
    private readonly intervalMs: number,
    private readonly onSample?: (level: number) => void,
  ) {}

  start(): void {
    this.stop();
    this.timer = window.setInterval(() => {
      const level = this.getLevel();
      this.peak = Math.max(this.peak, level);
      this.onSample?.(level);
    }, this.intervalMs);
  }

  stop(): void {
    if (this.timer !== null) {
      window.clearInterval(this.timer);
      this.timer = null;
    }
  }

  consumePeak(): number {
    const peak = this.peak;
    this.peak = 0;
    return peak;
  }

  peekPeak(): number {
    return this.peak;
  }
}
